module.exports = __webpack_public_path__ + "img/IT0000574292921.880fce10.png";